module.exports = "https://99designs-start-assets.imgix.net/js/21142fea16667406df87ee30560cd6f3.png";